export default "__VITE_ASSET__DB2JqegM__"